import { useState } from 'react';

import TableContainer from '@mui/material/TableContainer';
import FdlButton from '../buttons/FdlButton';
import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Paper,
    Typography
} from '@mui/material';

const fullWidth = {
    gridColumnStart: '1',
    gridColumnEnd: '13',
};

const buttonStyle = {
    marginTop: '20px',
    marginBottom: '20px',
    ...fullWidth,
};

const dataCellStyle = {
    verticalAlign: 'top'
}

export default function ReviewTable(props) {
    const { intentName, intentDetails, cameraDetails } = props
    const [isOpen, setIsOpen] = useState(false);

    const openTableHandler = () => {
        setIsOpen(current => !current)
    };

    return (
        <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(12, 1fr)',
            gridColumnStart: '1',
            gridColumnEnd: '13',
        }}>
            <FdlButton
                onClick={openTableHandler}
                text="View Source Data"
                style={buttonStyle}
            />
            {isOpen ?
                <TableContainer component={Paper} sx={fullWidth}>
                    <Table>
                        {/* The Table Head */}
                        <TableHead>
                            <TableRow>
                                <TableCell>Framing Intent</TableCell>
                                <TableCell>Context</TableCell>
                                <TableCell>Camera</TableCell>
                            </TableRow>
                        </TableHead>

                        {/* The Table Body */}
                        <TableBody>
                            <TableRow>
                                <TableCell style={dataCellStyle}>
                                    <Typography>{intentName}</Typography>
                                    {Object.keys(intentDetails).map((key, i) => (
                                        <li key={i}>{key}: {intentDetails[key]}</li>
                                    ))}
                                </TableCell>

                                <TableCell style={dataCellStyle}>
                                    <Typography>Context 1</Typography>
                                </TableCell>

                                <TableCell style={dataCellStyle}>
                                    {Object.keys(cameraDetails).map((key, i) => (
                                        <li key={i}>{key}: {cameraDetails[key]}</li>
                                    ))}
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
                :
                <></>
            }
        </div>
    );
};